import debounce from "./helpers";

export default function triggerNavColorChange() {
  const isPresent = document.body.classList.contains("home");
  if (!isPresent) {
    return;
  }

  let scrollpos = window.scrollY;
  const nav = document.querySelector(".main-nav");

  function add_class_on_scroll() {
    nav.classList.add("main-nav--light");
  }

  function remove_class_on_scroll() {
    nav.classList.remove("main-nav--light");
  }

  function checkScroll() {
    //Here you forgot to update the value
    scrollpos = window.scrollY;

    if (scrollpos > 1000) {
      add_class_on_scroll();
    } else {
      remove_class_on_scroll();
    }
  }

  window.addEventListener("scroll", debounce(checkScroll));
}
